import React from 'react';
import PropTypes from 'prop-types';
// import { Dropdown } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { KanbanContext } from 'context/Context';

const KanbanColumnHeader = ({ title, itemCount}) => {
  // const { kanbanDispatch } = useContext(KanbanContext);

  return (
    <div className="kanban-column-header" style={{backgroundColor: '#e63757', color: '#fff'}}>
      <h5 className=" mb-0" style={{ fontSize: '.8rem', color: '#fff' }}>
        {title} <span  style={{color: '#fff'}}>({itemCount})</span>
      </h5>
    </div>
  );
};

KanbanColumnHeader.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  itemCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default KanbanColumnHeader;
